import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lvp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function buildDownloadUrl(path) {
  const token = localStorage.getItem("lvp_token") || "";
  const sep = path.includes("?") ? "&" : "?";
  return `${BACKEND_URL}${path}${sep}token=${encodeURIComponent(token)}`;
}

/**
 * Programmatically download a file using the API token, bypassing
 * cross-origin / inline-render quirks of plain <a href download>.
 */
export async function downloadFile(path, filename) {
  const token = localStorage.getItem("lvp_token");
  const url = path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await fetch(url, { headers });
  if (!res.ok) {
    let msg = `Download failed (${res.status})`;
    try {
      const j = await res.json();
      if (j?.detail) msg = formatApiError(j.detail);
    } catch (_) { /* ignore */ }
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  // Try to extract filename from Content-Disposition
  let suggested = filename;
  if (!suggested) {
    const cd = res.headers.get("content-disposition") || "";
    const m = /filename="?([^";]+)"?/i.exec(cd);
    if (m) suggested = m[1];
  }
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = suggested || "download";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}

export default api;
